import { ACCOUNT_FEATURE, MODAL, selectUserRolePermissions } from '@socialive/common';
import { useFeature } from '@socialive/features';
import { useModal } from '@socialive/modals';
import { LoadingIcon } from '@socialive/ui';
import { useSelector } from 'react-redux';
import { selectAreUploadsInProgress } from '~/store';

export default function UploadMediaButton() {
  const { canUploadVideo } = useSelector(selectUserRolePermissions);
  const areUploadsInProgress = useSelector(selectAreUploadsInProgress);
  const [, { enabled: mediaUploadEnabled }] = useFeature(ACCOUNT_FEATURE.MEDIA_UPLOAD);
  const mediaUploadModal = useModal({ modalId: MODAL.MEDIA_UPLOAD, trigger: 'UploadMediaButton' });

  if (!mediaUploadEnabled || !canUploadVideo) return null;

  return (
    <button type="button" className="btn btn-media-upload" onClick={mediaUploadModal.open}>
      {areUploadsInProgress && (
        <>
          <LoadingIcon className="animate-spin-slow" />
          Uploading
        </>
      )}
      {!areUploadsInProgress && 'Upload'}
    </button>
  );
}
